import { createApp, Directive } from 'vue'
import App from './App.vue'
import router from './router'
// import mitt, { Emitter } from 'mitt'
import mitt from 'mitt'
import { store, useStore } from './store'
import '@/assets/iconfont/iconfont.css'
import '@/assets/styles/reset.css'
import '@/assets/styles/global.styl'
import installElementPlus from './plugins/element'
import { HttpService } from './utils/http/index'
import * as directives from '@/directives'
import '@/router/permission'
import * as echarts from 'echarts'
// import { NoticeBar, Swipe, SwipeItem } from 'vant'
import { saveJsError } from '@/apis/app'
const app = createApp(App)

app.config.globalProperties.$echarts = echarts
const mitter = mitt()
app.config.globalProperties.$http = new HttpService()
app.config.globalProperties.$eBus = mitter
installElementPlus(app)

// 异常捕获
// app.config.errorHandler = function (err:any, vm, info) {
//     const url = window.location.href
//     const userInfo = useStore().state.user.userInfo
//     if (url.indexOf('v-admin') === -1) { return } // 仅生产环境上报
//     saveJsError({
//         platform: 'v-admin',
//         msg: `${userInfo.username}：${err.toString()}`,
//         url,
//         line: 1
//     })
// }

// 自定义指令
Object.keys(directives).forEach(key => {
    app.directive(key, (directives as { [key: string]: Directive})[key])
})

// app.use(store).use(router).use(NoticeBar).use(Swipe).use(SwipeItem).mount('#app')
app.use(store).use(router).mount('#app')
